function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import Icon from './lib/icon';
export const IconClose = (props)=>/*#__PURE__*/ _jsx(Icon, _object_spread_props(_object_spread({}, props), {
        path: "m16 14.727 7.864-7.864a.897.897 0 0 1 1.272 0 .897.897 0 0 1 0 1.273L17.273 16l7.863 7.863a.9.9 0 0 1 0 1.273.897.897 0 0 1-1.272 0L16 17.272l-7.864 7.864a.897.897 0 0 1-1.272 0 .897.897 0 0 1 0-1.273L14.727 16 6.864 8.136a.897.897 0 0 1 0-1.273.897.897 0 0 1 1.272 0z"
    }));
export const IconCollapse = (props)=>/*#__PURE__*/ _jsx(Icon, _object_spread_props(_object_spread({}, props), {
        path: "m16 12.252 7.293 7.455a1 1 0 0 0 1.414 0 .997.997 0 0 0 0-1.414l-8.002-8a.997.997 0 0 0-1.414 0l-7.998 8a.997.997 0 0 0 0 1.414c.199.199.353.293.707.293s.515-.101.707-.293z"
    }));
export const IconExpand = (props)=>/*#__PURE__*/ _jsx(Icon, _object_spread_props(_object_spread({}, props), {
        path: "m16 19.748-7.293-7.455a1 1 0 0 0-1.414 0 .997.997 0 0 0 0 1.414l8.002 8a.997.997 0 0 0 1.414 0l7.998-8a.997.997 0 0 0 0-1.414C24.508 12.094 24.354 12 24 12s-.515.101-.707.293z"
    }));
export const IconEnlarge = (props)=>/*#__PURE__*/ _jsx(Icon, _object_spread_props(_object_spread({}, props), {
        path: "m22.75 24-4.959-4.85a1 1 0 1 1 1.42-1.409L24 22.737l-.252-3.232a1 1 0 1 1 1.998-.103L26 24.365c.001.924-.704 1.635-1.578 1.635l-4.971-.25a1 1 0 1 1 .1-1.997zM9.278 24l3.198-.247a1 1 0 1 1 .101 1.997l-4.97.25c-.875 0-1.58-.711-1.579-1.635l.255-4.963a1 1 0 0 1 1.997.103l-.252 3.232 4.789-4.996a1 1 0 1 1 1.42 1.408zM24 9.25l-4.85 4.959a1 1 0 1 1-1.409-1.42L22.737 8l-3.232.252a1 1 0 0 1-.103-1.998L24.365 6C25.289 5.999 26 6.704 26 7.578l-.25 4.971a1 1 0 1 1-1.997-.1zm-16.028 0 .247 3.198a1 1 0 0 1-1.997.101l-.25-4.97c0-.875.711-1.58 1.635-1.579l4.963.254a1 1 0 0 1-.103 1.998L9.235 8l4.996 4.789a1 1 0 1 1-1.408 1.42z"
    }));
export const IconShrink = (props)=>/*#__PURE__*/ _jsx(Icon, _object_spread_props(_object_spread({}, props), {
        path: "M25.293 5.293a1 1 0 0 1 1.414 1.414L21.25 12l3.704-.245a1 1 0 0 1 .092 1.998L19.63 14c-.9 0-1.631-.73-1.63-1.68l.255-5.337a1 1 0 1 1 1.998.095L20 10.75zm-18.585 0 5.293 5.457-.254-3.672a1 1 0 1 1 1.998-.095L14 12.321c.001.949-.73 1.679-1.63 1.679l-5.415-.247a1 1 0 1 1 .092-1.998L10.75 12 5.294 6.707a1 1 0 0 1 1.414-1.414m20 19.999a1 1 0 1 1-1.415 1.414L20 21.249l.245 3.704a1 1 0 1 1-1.998.092L18 19.63c0-.9.73-1.631 1.68-1.63l5.337.255a1 1 0 0 1-.095 1.998l-3.672-.254zm-21.415 0 5.457-5.293-3.672.254a1 1 0 1 1-.095-1.998L12.321 18c.949-.001 1.679.73 1.679 1.63l-.247 5.415a1 1 0 1 1-1.998-.092L12 21.25l-5.293 5.457a1 1 0 0 1-1.414-1.414"
    }));
export const IconLinkInternal = (props)=>/*#__PURE__*/ _jsx(Icon, _object_spread_props(_object_spread({}, props), {
        path: "m19.748 16-7.455 7.293a1 1 0 0 0 0 1.414.997.997 0 0 0 1.414 0l8-8.002a.997.997 0 0 0 0-1.414l-8-7.998a.997.997 0 0 0-1.414 0C12.094 7.492 12 7.646 12 8s.101.515.293.707z"
    }));
export const IconLinkExternal = (props)=>/*#__PURE__*/ _jsx(Icon, _object_spread_props(_object_spread({}, props), {
        path: "M22 22v-4a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h4.998a1 1 0 0 1 0 2H10v12zm1.91-12.482-6.197 6.299a1 1 0 0 1-1.426-1.403l6.225-6.328-3.466.159a1 1 0 0 1-.092-1.998L24.37 6c.9 0 1.631.73 1.63 1.68l-.255 5.337a1 1 0 1 1-1.998-.095z"
    }));
export const IconMenu = (props)=>/*#__PURE__*/ _jsx(Icon, _object_spread_props(_object_spread({}, props), {
        path: "M6 17.018a1 1 0 1 1 0-2h20a1 1 0 0 1 0 2zm0 5.972a1 1 0 0 1 0-2h20a1 1 0 1 1 0 2zM6 11a1 1 0 0 1 0-2h20a1 1 0 0 1 0 2z"
    }));
export const IconMore = (props)=>/*#__PURE__*/ _jsx(Icon, _object_spread_props(_object_spread({}, props), {
        path: "M7.997 18a2.001 2.001 0 0 1 0-4C9.101 14 10 14.897 10 16s-.899 2-2.003 2M14 16a2 2 0 0 1 4 0c0 1.103-.899 2-2.003 2A2 2 0 0 1 14 16m9.997 2a2.001 2.001 0 0 1 0-4c1.104 0 2.003.897 2.003 2s-.899 2-2.003 2"
    }));
export const IconNext = (props)=>/*#__PURE__*/ _jsx(Icon, _object_spread_props(_object_spread({}, props), {
        path: "m19.748 16-7.455 7.293a1 1 0 0 0 0 1.414.997.997 0 0 0 1.414 0l8-8.002a.997.997 0 0 0 0-1.414l-8-7.998a.997.997 0 0 0-1.414 0C12.094 7.492 12 7.646 12 8s.101.515.293.707z"
    }));
export const IconPrevious = (props)=>/*#__PURE__*/ _jsx(Icon, _object_spread_props(_object_spread({}, props), {
        path: "m12.252 16 7.455-7.293a1 1 0 0 0 0-1.414.997.997 0 0 0-1.414 0l-8 8.002a.997.997 0 0 0 0 1.414l8 7.998a.997.997 0 0 0 1.414 0c.199-.199.293-.353.293-.707s-.101-.515-.293-.707z"
    }));
export const IconFirst = (props)=>/*#__PURE__*/ _jsx(Icon, _object_spread_props(_object_spread({}, props), {
        path: "M23.753 8.658a1 1 0 0 0-1.417-1.406l-.089.09-7 8.001a1 1 0 0 0-.075 1.22l.075.097 7 7.999a1 1 0 0 0 1.582-1.218l-.076-.1-6.424-7.339zM10 7a1 1 0 0 1 .993.883L11 8v16a1 1 0 0 1-1.993.117L9 24V8a1 1 0 0 1 1-1"
    }));
export const IconLast = (props)=>/*#__PURE__*/ _jsx(Icon, _object_spread_props(_object_spread({}, props), {
        path: "M16.753 16.66a1 1 0 0 0 .075-1.219l-.075-.098-7-8.001A1 1 0 0 0 8.17 8.559l.076.1 6.425 7.343-6.425 7.34a1 1 0 0 0 .005 1.322l.09.089a1 1 0 0 0 1.322-.005l.089-.09zM22 7a1 1 0 0 1 .993.883L23 8v16a1 1 0 0 1-1.993.117L21 24V8a1 1 0 0 1 1-1"
    }));
export const IconUp = (props)=>/*#__PURE__*/ _jsx(Icon, _object_spread_props(_object_spread({}, props), {
        path: "M17 24c0 .552-.5 1-1 1s-1-.448-1-1V10l-4.822 4.735a.998.998 0 0 1-1.678-.742 1 1 0 0 1 .322-.728l6.5-6a1 1 0 0 1 1.356 0l6.5 6a1 1 0 0 1 .057 1.413.997.997 0 0 1-1.413.057L17 10z"
    }));
export const IconDown = (props)=>/*#__PURE__*/ _jsx(Icon, _object_spread_props(_object_spread({}, props), {
        path: "M17 8c0-.552-.5-1-1-1s-1 .448-1 1v14l-4.822-4.735a.998.998 0 0 0-1.678.742c.002.267.11.533.322.728l6.5 6a1 1 0 0 0 1.356 0l6.5-6a1 1 0 0 0 .057-1.413.997.997 0 0 0-1.413-.057L17 22z"
    }));
export const IconLeft = (props)=>/*#__PURE__*/ _jsx(Icon, _object_spread_props(_object_spread({}, props), {
        path: "M24 17c.552 0 1-.5 1-1s-.448-1-1-1H10l4.735-4.822a.998.998 0 0 0-.742-1.678 1 1 0 0 0-.728.322l-6 6.5a1 1 0 0 0 0 1.356l6 6.5a1 1 0 0 0 1.413.057.997.997 0 0 0 .057-1.413L10 17z"
    }));
export const IconRight = (props)=>/*#__PURE__*/ _jsx(Icon, _object_spread_props(_object_spread({}, props), {
        path: "M8 17c-.552 0-1-.5-1-1s.448-1 1-1h14l-4.735-4.822a.998.998 0 0 1 .742-1.678c.267.002.533.11.728.322l6 6.5a1 1 0 0 1 0 1.356l-6 6.5a1 1 0 0 1-1.413.057.997.997 0 0 1-.057-1.413L22 17z"
    }));
